import {InstancedMesh} from 'three';
import {sRGBEncoding} from 'three';
import {MeshBasicMaterial} from 'three';

export default class SceneOptimizer
{
  constructor(scene)
  {
    let regex = new RegExp('^instanced_');

    let instancify = this.instancify;

    scene.traverse((child)=>{
      if(regex.test(child.name) && child.type === 'Object3D')
      {
        instancify(child);
      }
    })
  }


  instancify(parent_object)
  {

    // if(parent_object.name !== 'instanced_factory_building1')
    // {
    //   return
    // }

    let children = parent_object.children;

    let regex = new RegExp('^reference_');

    let reference_child = children[0];
    for(let i=0; i<parent_object.children.length; i++)
    {
      if(regex.test(parent_object.children[i].name))
      {
        reference_child = parent_object.children[i];
        break;
      }
    }
    if(reference_child.material.map)
    {
      reference_child.material = new MeshBasicMaterial({
        map: reference_child.material.map,
        transparent: reference_child.material.transparent,
        alphaTest: reference_child.material.alphaTest,
        alphaToCoverage: reference_child.material.alphaToCoverage,
        side: reference_child.material.side
      })
      reference_child.material.map.encoding = sRGBEncoding;
    }
    let instanced_child = new InstancedMesh(reference_child.geometry, reference_child.material, children.length);

    
    let index = 0;
    while(parent_object.children.length > 0)
    {
      let child = parent_object.children.shift()
      // child.rotation.x = 0;
      // child.rotation.y = 0;
      // child.rotation.z = 0;
      if(parent_object.parent.name !== 'roads')
      {
        child.scale.set(1,1,1)

      }
      child.updateMatrix();
      instanced_child.setMatrixAt(index, child.matrix)
      index++;
    }

    instanced_child.name = "InstancedMesh"
    parent_object.add(instanced_child);
    instanced_child.instanceMatrix.needsUpdate = true;
  }


}